module.exports = __webpack_public_path__ + "img/periode_akhir.e99698a4.svg";